export default "/img/VA.86f896ba355096468052a550aa11ff7c.png";